import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsEducational from '../../../components/video-production/explainer-videos/BenefitsEducational';
import ProcessSliderEducational from '../../../components/sliders/ProcessSliderEducational';
import SolveProblemsEducational from '../../../components/video-production/explainer-videos/SolveProblemsEducational';

lazyload({
  width: '100%',
});

const ExplainerVideosEducational = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Educational Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/educational-explainer-video" />
        <meta
          name="description"
          content="Discover how our educational explainer video service can transform learning! Engage audiences with captivating content. Let's make education exciting!"
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/educational-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Educational Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Discover how our educational explainer video service can transform learning! Engage audiences with captivating content. Let's make education exciting!"
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/educational-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
  "@context": "http://schema.org",
  "@type": "WebPage",
  "name": "Video Production - Educational Explainer Video | Prodigi",
  "description": "Discover how our educational explainer video service can transform learning! Engage audiences with captivating content. Let's make education exciting! ",
  "url": "https://weprodigi.com/video-production/educational-explainer-video",
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://weprodigi.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Full Service Video Production",
        "item": "https://weprodigi.com/video-production"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Educational Explainer Video Production ",
        "item": "https://weprodigi.com/video-production/educational-explainer-video"
      }
    ]
  },
  "mainEntity": {
    "@type": "Product",
    "name": "Educational Explainer Video Production",
    "description": "Discover how our educational explainer video service can transform learning! Engage audiences with captivating content. Let's make education exciting! ",
    "brand": {
      "@type": "Brand",
      "name": "Weprodigi"
    },
    "offers": {
      "@type": "Offer",
      "price": "1300",
      "priceCurrency": "USD",
      "seller": {
        "@type": "Organization",
        "name": "Weprodigi"
      }
    },
    "image": "https://weprodigi.com/images/logovertical.svg",
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Amir  Moghateli "
        },
        "datePublished": "2024-03-18",
        "reviewBody": "Working with Prodigi was a breeze. Their team understood our needs perfectly and delivered stunning explainer videos that exceeded our expectations. Five stars!"
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Sam Lake"
        },
        "datePublished": "2024-02-11",
        "reviewBody": "Prodigi combines creativity with educational expertise to produce top-quality explainer videos. Their attention to detail and commitment to client satisfaction shines through in every project. Highly satisfied!"
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "4.9",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Hanna Matuzka"
        },
        "datePublished": "2024-02-2",
        "reviewBody": "Impressed with Prodigi's ability to turn our ideas into engaging educational videos. Professional, timely, and results-driven. Will definitely work with them again!"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "3"
    }
  }
}
`,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/educational-explainer/educational-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Educational Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/educational-explainer-video',
                name: 'Educational Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  An educational explainer video reactivates attention during learning sessions. It stands as a unique break pathway between long
                  lectures and paragraphs. Learn more about the modern transformation method of education processes!
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full lg:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is an Educational Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/FuCO0RDxcxc?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>De Courten Solutions | Educational Explainer Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                An educational explainer video is a short, engaging video clip. Generally lasting between 1 to 3 minutes, it explains complex subjects
                by simplifying them. A learning explainer is an interactive visualisation of educational content without limitations on styles and
                topics. It's a helpful instrument for developing learning experiences. Also, the format makes effective educational visual content.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  An educational explainer video is a short, engaging video clip. Generally lasting between 1 to 3 minutes, it explains complex
                  subjects by simplifying them. A learning explainer is an interactive visualisation of educational content without limitations on
                  styles and topics. It's a helpful instrument for developing learning experiences. Also, the format makes effective educational
                  visual content.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use Educational Explainer Video?
            </h2>
            <p className={'mt-20'}>
              Educational visual content gives a new breath to the learning materials. Dive into how these videos can update learning programs of
              different industries.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/9DrCYTK605Q?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Safe Room | Educational Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  It takes work to stand out from competitors. An educational explainer video is a new method for creating a brand identity. Simplify
                  complex information about your educational products and engage new students. Educational video production highlights all the
                  advantages of your e-learning courses, educational apps, workshops, or seminars. Simplified information builds trust in your
                  educational platform, whether it's a private school, university, or academy.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    It takes work to stand out from competitors. An educational explainer video is a new method for creating a brand identity.
                    Simplify complex information about your educational products and engage new students. Educational video production highlights all
                    the advantages of your e-learning courses, educational apps, workshops, or seminars. Simplified information builds trust in your
                    educational platform, whether it's a private school, university, or academy.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  Do you need to change your learning methods for the better? Research shows that people understand things better when they see them.
                  Video production for students makes it easy to understand complex sciences such as mathematics, linguistics, etc. Explainer videos
                  develop your educational content, meeting the diverse needs of a wide range of learners. Provide a creative and effective approach
                  to your learning management systems, school or university materials, or employee training processes for creating better
                  understanding.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Do you need to change your learning methods for the better? Research shows that people understand things better when they see
                    them. Video production for students makes it easy to understand complex sciences such as mathematics, linguistics, etc. Explainer
                    videos develop your educational content, meeting the diverse needs of a wide range of learners. Provide a creative and effective
                    approach to your learning management systems, school or university materials, or employee training processes for creating better
                    understanding.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/ekHMg8JcKr4?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Grovider online | Educational Explainer Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/ZF7XNWSFj_s?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Rescuing Hope | Educational Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Public Communication</h3>
                <p className={'mt-16 hidden md:block'}>
                  How do you bridge your project with its target audience? Good communication is the short answer. Educational animation or
                  live-action videos simplify communication processes. They make projects more successful and raise awareness in the company.
                  Explainer video is a powerful tool for government organisations, NGOs, and other companies. They share necessary information with
                  the public, offering solutions for public issues, and informing about new laws, human rights, and healthcare actions. Overall,
                  visualised communication speeds up the spreading of public education campaigns.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    How do you bridge your project with its target audience? Good communication is the short answer. Educational animation or
                    live-action videos simplify communication processes. They make projects more successful and raise awareness in the company.
                    Explainer video is a powerful tool for government organisations, NGOs, and other companies. They share necessary information with
                    the public, offering solutions for public issues, and informing about new laws, human rights, and healthcare actions. Overall,
                    visualised communication speeds up the spreading of public education campaigns.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Educational Explainer Videos
            </h2>
            <p className={'mt-20'}>
              Ready to develop your traditional learning methods? Learn about explainer video, or explainer animation service's benefits and make
              changes for the better!
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsEducational />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Educational Explainer Video Production Process
            </h2>
            <ProcessSliderEducational />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-26 lg:text-36'
              }
            >
              CALCULATE YOUR EDUCATIONAL EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Educational Explainer Videos Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              Explainer video is one of the necessary parts of succeeding in marketing campaigns. Learn the main advantages that can be useful for
              your business.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsEducational />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Educational Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We value your time.',
                  answer:
                    "We know how important our clients' time is. Outsourcing full-service video production helps save your expensive time. More importantly, we quickly understand your business needs and implement our proven time-saving solutions at all stages of production, from communication to payment methods.",
                },
                {
                  title: 'We include digital marketing specialists in the production process.',
                  answer:
                    "According to Google, 6 out of 10 people prefer watching videos online rather than TV. To create an effective video, you need to consider which platform the video will be used on and master all its features, be it your website, YouTube, Facebook, or Amazon. That's why we include our digital marketing specialists in the production process, who study your business requirements in detail and combine them with the requirements of each online platform to get effective material.",
                },
                {
                  title: "We don't require prepayment.",
                  answer:
                    "The client should pay for the work rather than with deposits. We chose a milestone payment option as it's a more trustworthy approach to our work.",
                },
                {
                  title: "We don't have a single unhappy client.",
                  answer:
                    'We never charge for a product that you have not approved. If you are unsatisfied with the results, 100% money-back is guaranteed.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'Why explainer videos are important in an academic setting?',
                    answer:
                      'The ability to make a memorable impact and gain attention makes explainer videos an important addition to an academic setting. They also provide enhanced understanding, engagement, accessibility, and student-centred learning.',
                  },
                  {
                    title: 'Can educational explainer videos be personalised or customised?',
                    answer:
                      'Experienced educational video production companies can personalise or customise in the most suitable way for the product or company. ',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'How can I measure the effectiveness of an educational explainer video?',
                    answer:
                      'There are five metrics to measure the effectiveness of an explainer video. These are view count, watch time, click-through rate, conversion rate, and social shares.',
                  },
                  {
                    title: 'What makes a good educational explainer video?',
                    answer:
                      'Clear and concise content, optimised length and format, catchy visuals, and professional video production are the key elements of a good educational explainer video.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosEducational;
